import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullSharedCalendarsOption'));
const SharedCalendarsOption: LazyOption = createLazyOption(
    {
        key: 'sharedCalendars',
        titleStringKey: 'optionTitle_shareACalendar',
        searchTermsStringKey: 'optionTitle_shareACalendar',
        isHidden: () => {
            return !isFeatureEnabled('cal-sharing-settings') || IsShadowMailboxUser();
        },
        allowedOptionKeys: ['CalendarPublishing'],
    },
    lazyFullModule,
    m => m.default
);
export default SharedCalendarsOption;
